import { render, staticRenderFns } from "./ImageSortGrid.vue?vue&type=template&id=b039c8ee&scoped=true"
import script from "./ImageSortGrid.vue?vue&type=script&lang=js"
export * from "./ImageSortGrid.vue?vue&type=script&lang=js"
import style0 from "./ImageSortGrid.vue?vue&type=style&index=0&id=b039c8ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b039c8ee",
  null
  
)

export default component.exports